import React from 'react';

import {  Page, Text, View, Document, StyleSheet, Image, Font, Link} from '@react-pdf/renderer';
import logo from '../logo-horizontal.png';
import font from "../Montserrat-Regular.ttf";
import fontBold from "../Montserrat-Bold.ttf";
import moment from 'moment'

Font.register({ family: 'Montserrat', src: font, fontStyle: 'normal', fontWeight: 'normal' });
Font.register({ family: 'Montserrat', src: fontBold, fontStyle: 'normal', fontWeight: 'bold' });
//Font.registerHyphenationCallback(word => {
//    if (word.startsWith('http')) {
//        return [word];
//    } else {
//        this;
//    }
//});
const dontBreak = (word) => {
    // Return word parts in an array
    return [word];
}
const cleanUp = (dirty) => {

    var div = document.createElement('div');
    div.innerHTML = dirty;
    var links = div.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
        links[i].innerHTML += ' [ ' + links[i].href + ' ] ';
    }   
   return div.innerHTML.replace(/<[^>]*>?/gm, ''); 
}
// Create Document Component
const SummaryDocument = (props) => {

    // Create styles
    const styles = StyleSheet.create({
        body: {
            paddingTop: 25,
            paddingBottom: 60,
            paddingHorizontal: 35,
            fontFamily: 'Montserrat'
        },
        title: {
            fontSize: 24,
            textAlign: 'left',
            fontFamily: 'Times-Roman',
            color: '#001641',
            paddingBottom: 12,
            paddingTop: 12
        },
        table: {
            display: "table",
            width: "auto",
            marginBottom: 5,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#001641",
        },
        tableRowStyle: {
            flexDirection: "row",
        },
        tableRowStyleShaded: {
            flexDirection: "row",
            backgroundColor: '#f2f2f2'
        },
        tableColStyle: {
            width: (!props.excludeComment ? "30%" : "50%"),
            borderStyle: "solid",
            borderColor: "#bbb",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0
        },
        tableCellStyle: {
            textAlign: "left",
            margin: 0,
            padding: 5,
            fontSize: 10,
            color: '#001641',
            fontFamily: 'Montserrat'
        },

        firstTableColHeaderStyle: {
            width: (!props.excludeComment ? "40%" : "50%"),
            borderStyle: "solid",
            borderColor: "#bbb",
            borderBottomColor: "#001641",
            borderWidth: 1
        },
        tableColHeaderStyle: {
            width: (!props.excludeComment ? "30%" : "50%"),
            borderStyle: "solid",
            borderColor: "#bbb",
            borderBottomColor: "#001641",
            borderWidth: 1,
            borderLeftWidth: 0
        },
        firstTableColStyle: {
            width: (!props.excludeComment ? "40%" : "50%"),
            borderStyle: "solid",
            borderColor: "#bbb",
            borderWidth: 1,
            borderTopWidth: 0
        },
        tableCellHeaderStyle: {
            textAlign: "left",
            margin: 4,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#001641',
            fontFamily: 'Montserrat'
        },
        subtitle: {
            fontSize: 18,
            marginBottom: 5,
            marginTop: 5,
            color: '#001641',
            fontFamily: 'Times-Roman'
        },
        text: {        
            fontSize: 10,
            textAlign: 'left',
            marginBottom: 5,
            marginTop: 5,
            color: '#001641',
            fontFamily: 'Montserrat'
        },
        textBold: {
            marginTop: 12,
            marginBottom: 12,
            fontSize: 10,
            color: '#001641',
            fontFamily: 'Montserrat',
            fontWeight: 'bold'
        },
        header: {
            fontSize: 12,
            marginBottom: 20,
            textAlign: 'center',
            color: 'grey',
        },
        pageNumber: {
            position: 'absolute',
            fontSize: 10,
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'grey',
            fontFamily: 'Montserrat',
        },
        image: {
            marginVertical: 0,
            marginHorizontal: 0,
            heigth: 50,
            width: 155
        },
        important: {
            padding: 10,
            backgroundColor: '#ffcccc',
            fontSize: 10,
            color: '#001641',
            fontFamily: 'Montserrat'
        }
    });
    const filterQuestions = (q, cid, questionResponses, i) => {
      
        if (parseInt(q.categoryID) == parseInt(cid)) {
            var returnjsx = [];
            questionResponses.forEach((qr) => {
                if (parseInt(qr.questionID) == parseInt(q.questionID)) {
                    returnjsx.push(                       
                        <View key={q.questionID} style={i % 2 == 0 ? styles.tableRowStyle : styles.tableRowStyleShaded} wrap={!props.excludeComment ? true : false}>                           
                            <View style={styles.firstTableColStyle}><Text style={styles.tableCellStyle}>{q.questionText}</Text></View>
                             <View style={styles.tableColStyle}><Text style={styles.tableCellStyle}>{qr.responseText}</Text></View>
                            {!props.excludeComment ? <View style={styles.tableColStyle}><Text style={styles.tableCellStyle}>{qr.commentText}</Text></View> : <View />}
                        </View>
                    );
                }
            });
            return returnjsx;         

        }
    }
return (
    <Document>
        <Page size="A4" style={styles.body}>
            <Image
                style={styles.image}
                src={logo}
            />
            <Text style={styles.title}>Digital Uplift Check (DUC) Self-Assessment Tool</Text>   
            {props.subjectCode != '' ?  <Text style={styles.text}><Text style={styles.textBold}>Subject Code:</Text> {props.subjectCode}</Text> 
            : <Text /> }
            {props.facultyText && props.facultyText.length > 0 ?
                <React.Fragment>
                    <Text style={styles.text}><Text style={styles.textBold}>Faculty:</Text> {props.facultyText}</Text>
                    <Text style={styles.text}><Text style={styles.textBold}>School:</Text> {props.schoolText}</Text>
                </React.Fragment>
                : <Text style={styles.text}><Text style={styles.textBold}>Unit:</Text> {props.schoolText}, {props.entity}</Text>
            }
            <Text style={styles.text}>Unique ID: <Link src={props.appurl + "/summary/recall/" + props.uniqueID}>{props.uniqueID}</Link></Text>            
            <Text style={styles.important}><Text style={styles.textBold}>Important:</Text> Please keep a record of this so you can return to the <Link src={props.appurl}>DUC Tool online</Link> and update or complete your DUC.</Text>
         
            
            {props.categories.length > 0 ? props.categories.map((c, i) =>
                <View key={i} wrap={!props.excludeComment ? true : false}><Text style={styles.title}> {c.categoryText}</Text>

                    <View style={styles.table}>
                        <View style={styles.tableRowStyle}>
                            <View style={styles.firstTableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>Checkpoint</Text></View>
                            <View style={styles.tableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>Rating</Text></View>
                             {!props.excludeComment ? <View style={styles.tableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>Comment</Text></View> : <View />}
                         </View>
                        {props.questionResponses.length > 0 ?
                            props.questions.map((q,i) => filterQuestions(q, c.categoryID, props.questionResponses, i)
                        ): <View />}
                    </View>
                    {c.showSupport ? <View wrap={false}>
                        <Text style={styles.subtitle}>Support resources</Text>
                        <Text style={styles.text} hyphenationCallback={dontBreak}>{cleanUp(c.categoryResources)}</Text>
                    </View> : <View />}
                 </View>
            ) : <View />}
      

            <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                `${pageNumber} / ${totalPages}`
            )} fixed />
        </Page>
    </Document>
);
}
const SummaryChangeDocument = (props) => {

    // Create styles
    const styles = StyleSheet.create({
        body: {
            paddingTop: 25,
            paddingBottom: 60,
            paddingHorizontal: 35,
            fontFamily: 'Montserrat'
        },
        title: {
            fontSize: 24,
            textAlign: 'left',
            fontFamily: 'Times-Roman',
            color: '#001641',
            paddingBottom: 12,
            paddingTop: 12
        },
        table: {
            display: "table",
            width: "auto",
            marginBottom: 5,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#001641",
        },
        tableRowStyle: {
            flexDirection: "row",
        },
        tableRowStyleShaded: {
            flexDirection: "row",
            backgroundColor: '#f2f2f2'
        },
        tableColStyle: {
            width:  "25%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0
        },
        lastTableColStyle: {
            width: "15%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0
        },
        tableCellStyle: {
            textAlign: "left",
            margin: 0,
            padding: 5,
            fontSize: 10,
            color: '#001641',
            fontFamily: 'Montserrat'

        },

        firstTableColHeaderStyle: {
            width: "35%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderBottomColor: "#001641",
            borderWidth: 1
        },
        tableColHeaderStyle: {
            width: "25%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderBottomColor: "#001641",
            borderWidth: 1,
            borderLeftWidth: 0
        },
        lastTableColHeaderStyle: {
            width: "15%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderBottomColor: "#001641",
            borderWidth: 1,
            borderLeftWidth: 0
        },
        firstTableColStyle: {
            width: "35%",
            borderStyle: "solid",
            borderColor: "#bbb",
            borderWidth: 1,
            borderTopWidth: 0
        },
        
        tableCellHeaderStyle: {
            textAlign: "left",
            margin: 4,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#001641',
            fontFamily: 'Montserrat'
        },
        subtitle: {
            fontSize: 18,
            marginBottom: 5,
            marginTop: 5,
            color: '#001641',
            fontFamily: 'Times-Roman'
        },
        text: {
            marginTop: 8,
            marginBottom: 8,
            fontSize: 10,
            textAlign: 'justify',
            color: '#001641',
            fontFamily: 'Montserrat'
        },
        textBold: {
            marginTop: 12,
            marginBottom: 12,
            fontSize: 10,
            textAlign: 'justify',
            color: '#001641',
            fontFamily: 'Montserrat',
            fontWeight: 'bold'
        },
        header: {
            fontSize: 12,
            marginBottom: 20,
            textAlign: 'center',
            color: 'grey',
        },
        pageNumber: {
            position: 'absolute',
            fontSize: 10,
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'grey',
            fontFamily: 'Montserrat',
        },
        image: {
            marginVertical: 0,
            marginHorizontal: 0,
            heigth: 50,
            width: 155
        },
        important: {
            padding: 10,
            backgroundColor: '#ffcccc',
            fontSize: 10,
            textAlign: 'justify',
            color: '#001641',
            fontFamily: 'Montserrat'
        }
    });

    const filterQuestions = (q, cid, i) => {
        var qr = props.questionResponses.find(qr => qr.questionID == q.questionID);
        if (parseInt(q.categoryID) == parseInt(cid)) {
            var prevqr = props.prevQuestionResponses.find(qr => qr.questionID == q.questionID);

            return <View key={q.questionID} style={i % 2 == 0 ? styles.tableRowStyle : styles.tableRowStyleShaded}>
                <View style={styles.firstTableColStyle}><Text style={styles.tableCellStyle}>{q.questionText}</Text></View>
                <View style={styles.tableColStyle}>
                    {prevqr ? 
                   <React.Fragment>
                            <Text style={styles.tableCellStyle}><Text style={styles.textBold}>Rating:</Text> {prevqr.responseText}</Text>
                            {!props.excludeComment ? <Text style={styles.tableCellStyle}><Text style={styles.textBold}>Comment:</Text> {prevqr.commentText}</Text> : <React.Fragment />}
                        </React.Fragment>
                        : <Text />}
                </View> 
               
                <View style={styles.tableColStyle}>
                    {qr ? 
                        <React.Fragment>
                            <Text style={styles.tableCellStyle}><Text style={styles.textBold}>Rating:</Text> {qr.responseText}</Text>
                            {!props.excludeComment ? <Text style={styles.tableCellStyle}><Text style={styles.textBold}>Comment:</Text> {qr.commentText}</Text> : <React.Fragment />}
                        </React.Fragment>
                        : <Text />}
                </View>

                <View style={styles.lastTableColStyle}>
                    <Text style={styles.tableCellStyle}>
                        <Text style={styles.textBold}>{prevqr && qr ? <React.Fragment>{qr.responseText == prevqr.responseText ? <React.Fragment>no change</React.Fragment> : <React.Fragment>change</React.Fragment>}</React.Fragment> : <React.Fragment>N/A</React.Fragment>}
                </Text></Text> 
                    </View>
                 
            </View>;
        }

    }
    return (
        <Document>
            <Page size="A4" style={styles.body}>
                <Image
                    style={styles.image}
                    src={logo}
                />
                <Text style={styles.title}>Digital Uplift Check (DUC) Tool</Text>
                {props.subjectCode != '' ? <Text style={styles.text}><Text style={styles.textBold}>Subject Code:</Text> {props.subjectCode}</Text>
                    : <Text />}
                {props.responseMeta.faculty && props.responseMeta.faculty.length > 0 ?
                    <React.Fragment>
                        <Text style={styles.text}><Text style={styles.textBold}>Faculty:</Text> {props.responseMeta.faculty}</Text>
                        <Text style={styles.text}><Text style={styles.textBold}>School:</Text> {props.responseMeta.unit}</Text>
                    </React.Fragment>
                    : <Text style={styles.text}><Text style={styles.textBold}>Unit:</Text> {props.responseMeta.unit}, {props.responseMeta.entity}</Text>
                }
                <Text style={styles.text}><Text style={styles.textBold}>Unique ID:</Text> <Link src={props.appurl + "/summary/recall/" + props.uniqueID}>{props.uniqueID}</Link></Text>
                <Text style={styles.important}><Text style={styles.textBold}>Important:</Text> Please keep a record of this so you can return to the  <Link src={props.appurl}>DUC Tool online</Link> and update or complete your DUC. </Text>

            

                {props.categories.length > 0 ? props.categories.map((c, i) =>
                    <View key={i}><Text style={styles.title}> {c.categoryText}</Text>
                        <View style={styles.table}>
                            <View style={styles.tableRowStyle} fixed>
                                <View style={styles.firstTableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>Checkpoint</Text></View>
                                <View style={styles.tableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>DUC completed on {moment(props.prevResponseMeta.createdDate).format("DD MMM YYYY")}</Text></View>
                             <View style={styles.tableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>DUC completed on {moment(props.responseMeta.createdDate).format("DD MMM YYYY")}</Text></View>
                                <View style={styles.lastTableColHeaderStyle}><Text style={styles.tableCellHeaderStyle}>Rating change</Text></View>
                            </View>
                            {props.questionResponses.length > 0 ?
                                props.questions.map((q, i) => filterQuestions(q, c.categoryID, i)
                                ) : <View />}
                        </View>          
                    </View>
                ) : <View />}

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                )} fixed />
            </Page>
        </Document>
    );
}
export default SummaryDocument;
export { SummaryDocument, SummaryChangeDocument };